import React, { Component } from 'react';
import yaml from 'js-yaml';

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import WordSec from '../components/WordSec'
import WordBtn from '../components/WordBtn'
import ListSec from '../components/ListSec'
import SlideShow from '../components/SlideShow'
import PicWordSec from '../components/PicWordSec'
import WordPicSec from '../components/WordPicSec'
import SelfIntro from '../components/SelfIntro'
import NewsItem from '../components/NewsItem'
import FiveWItem from '../components/FiveWItem'
import PartnerSec from '../components/PartnerSec'
import PicDisplay from '../components/PicDisplay'
import IconWord from '../components/IconWord'
import SmallWordPicSec from '../components/SmallWordPicSec'
import TopPicDownWordSec from '../components/TopPicDownWordSec'
import SpecItem from '../components/SpecItem'

import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'

import '../css/old_web.css';
import '../css/TechPage.css';
import { buildPath } from '../utils/route_utils.js'
import { updateProductSEO } from '../utils/seo_utils'


class TechPage extends Component {

  constructor(props) {
    super(props);

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const pageId = pathParts.length >= 3 ? pathParts[2] : 'collie';

    this.state = {
      id: pageId,
      lang: this.props.lang,
      tech_page_icon_flag: true,
      tech_page_flag: false,
      tech_page_title: {"en": [], "zh": [], "ja": []},
      tech_page_desc: {"en": [], "zh": [], "ja": []},
      tech_page_img: [],
      web_content: {"": []},
      product: [],
      switch_page_flag: false,
    }

    this.get_data = this.get_data.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    this.get_data(this.state.id)
    updateProductSEO(this.state.id, this.state.lang, '/tech/' + this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    if (win != null) {
      win.focus();
    }
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  renderVideoSection(item, index) {
    const vlinks = item.video_link || [];
    const lang = this.state.lang;
    const videoLabel = { zh: '產品影片', en: 'Product Video', ja: '製品動画' };
    const isSingle = vlinks.length === 1;

    return (
      <div key={index} className="tech_video_section">
        <div className="tech_video_section__inner">
          <div className="tech_video_section__header">
            <h2>{videoLabel[lang]}</h2>
          </div>
          <div className={`tech_video_section__grid ${isSingle ? 'tech_video_section__grid--single' : 'tech_video_section__grid--multi'}`}>
            {vlinks.map((link, i) => (
              <div key={i} className="tech_video_wrap">
                <iframe
                  src={link}
                  title={`video-${i}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const lang = this.state.lang;

    const productName = this.state.tech_page_title || { zh: this.state.id, en: this.state.id, ja: this.state.id };
    const breadcrumbItems = [
      { label: { zh: "產品", en: "Products", ja: "製品" }, route: '/solutions' },
      { label: productName }
    ];

    return (
      <div id="body" className="tech_page">
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={breadcrumbItems} />

        <div className="tech_section">
          {/* Hero Banner */}
          <div className="tech_hero">
            <h1>{this.state.tech_page_title[lang]}</h1>
            <p className="tech_hero__model">{this.state.tech_page_desc[lang]}</p>
          </div>

          {/* Content sections */}
          {Object.keys(this.state.web_content).map((key_name, i) => (
            <React.Fragment key={i}>
              {this.state.web_content[key_name].map((item, index) => {

                if (item["type"] === "tech_intro") {
                  return (
                    <div key={index} className="tech_intro_v2">
                      <div className="tech_intro_v2__image" style={{backgroundImage: 'url(' + item["img"] + ')'}} />
                      <div className="tech_intro_v2__body">
                        <img src={"/assets/mainpage_nexuni_white_icon.png"} alt="" />
                        <h3 dangerouslySetInnerHTML={{__html: item["content"][lang]}} />
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "tech_cus_and_ps") {
                  return (
                    <div key={index} className="tech_challenges">
                      <div className="tech_challenges__card">
                        <h3>{item["title_cus"][lang]}</h3>
                        <h4 dangerouslySetInnerHTML={{__html: item["content_cus"][lang]}} />
                      </div>
                      <div className="tech_challenges__card">
                        <h3>{item["title_ps"][lang]}</h3>
                        <h4 dangerouslySetInnerHTML={{__html: item["content_ps"][lang]}} />
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "pic_word_section") {
                  return (
                    <div key={index} className="tech_feature">
                      <div className="tech_feature__image" style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + item["img"] + ')'}} />
                      <div className="tech_feature__body">
                        <h3>{item["title"][lang]}</h3>
                        <h4 dangerouslySetInnerHTML={{__html: item["content"][lang]}} />
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "word_pic_section") {
                  return (
                    <div key={index} className="tech_feature tech_feature--reverse">
                      <div className="tech_feature__image" style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + item["img"] + ')'}} />
                      <div className="tech_feature__body">
                        <h3>{item["title"][lang]}</h3>
                        <h4 dangerouslySetInnerHTML={{__html: item["content"][lang]}} />
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "video_gallery") {
                  return this.renderVideoSection(item, index);
                }

                if (item["type"] === "spec_item") {
                  return (<SpecItem key={index} lang={lang} img={item["img"]} title={item["title"]} content={item["content"]} />);
                }

                if (item["type"] === "word_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <WordSec className="general_section" title={item["title"][lang]} content={item["content"][lang]} style={item["style"]} />
                    </div>
                  );
                }

                if (item["type"] === "word_btn") {
                  return (
                    <div key={index} className="tech_content_area">
                      <WordBtn action={item["action"]} className="general_section" title={item["title"][lang]} content={item["content"][lang]} style={item["style"]} />
                    </div>
                  );
                }

                if (item["type"] === "list_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <ListSec className="general_section" title={item["title"][lang]} content={item["content"][lang]} main_title={item["main_title"][lang]} />
                    </div>
                  );
                }

                if (item["type"] === "slide_show") {
                  return (<SlideShow lang={lang} key={index} title={item["title"]} content={item["content"]} action={item["action"]} img={item["img"]} img_num={item["img_num"]} logo_flag={false} />);
                }

                if (item["type"] === "top_pic_down_word_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <div className="two_item_holder">
                        {item["img"].map((img_src, tpdw_i) =>
                          <TopPicDownWordSec key={tpdw_i} img={img_src} title={item["title"][lang][tpdw_i]} content={item["content"][lang][tpdw_i]} style={item["style"]} />
                        )}
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "small_word_pic_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <SmallWordPicSec action={item["action"]} className="general_section" img={item["img"]} title={item["title"][lang]} content={item["content"][lang]} style={item["style"]} />
                    </div>
                  );
                }

                if (item["type"] === "self_intro") {
                  return (
                    <div key={index} className="tech_content_area">
                      <SelfIntro className="general_section" content={item["content"]} />
                    </div>
                  );
                }

                if (item["type"] === "news_item") {
                  return (
                    <div key={index} className="tech_content_area">
                      <NewsItem className="general_section" content={item["content"]} lang={lang} />
                    </div>
                  );
                }

                if (item["type"] === "five_w_item") {
                  return (
                    <div key={index} className="tech_content_area">
                      <FiveWItem className="general_section" title={item["title"][lang]} content={item["content"][lang]} />
                    </div>
                  );
                }

                if (item["type"] === "title_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <div className="title_section_holder"><h1>{item["title"][lang]}</h1></div>
                    </div>
                  );
                }

                if (item["type"] === "partner_section") {
                  return (
                    <div key={index} className="tech_content_area">
                      <PartnerSec img={item["img"]} title={item["title"][lang]} action={item["action"]} />
                    </div>
                  );
                }

                if (item["type"] === "pic_display") {
                  return (
                    <div key={index} className="tech_content_area">
                      <PicDisplay img={item["img"]} title={item["title"][lang]} style={item["style"]} />
                    </div>
                  );
                }

                if (item["type"] === "video_display") {
                  return (<iframe key={index} width="100%" height="700px" src={item["video_src"]} title="video" />);
                }

                if (item["type"] === "icon_word") {
                  return (
                    <div key={index} className="tech_content_area">
                      <div className="icon_word_holder">
                        {item["title"][lang].map((title, ic) => (<IconWord key={ic} style={item["style"]} img={item["img"][ic]} title={title} />))}
                      </div>
                    </div>
                  );
                }

                if (item["type"] === "related_products") {
                  return (
                    <div key={index} className="tech_related_products">
                      <h2 className="tech_related_products__title">{item["section_title"][lang]}</h2>
                      <div className="tech_related_products__grid">
                        {item["items"].map((rp, rpIdx) => (
                          <div
                            key={rpIdx}
                            className={"tech_related_products__card" + (rp.id === this.state.id ? " tech_related_products__card--active" : "")}
                            onClick={() => { if (rp.id !== this.state.id) this.navigate('/tech/' + rp.id); }}
                          >
                            <div className="tech_related_products__card_img">
                              <img src={rp.img} alt={rp.title[lang]} />
                            </div>
                            <div className="tech_related_products__card_body">
                              <h4>{rp.title[lang]}</h4>
                              <p>{rp.desc[lang]}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }

                return null;
              })}
            </React.Fragment>
          ))}
        </div>

        <Footer lang={lang} navigate={(route) => this.navigate(route)} />
      </div>
    );
  }

  get_data(page_title) {
    fetch(process.env.PUBLIC_URL + '/yaml/product_info.yaml')
      .then(response => response.text())
      .then(text => {
        const tech_content = yaml.load(text)["tech_content"];
        this.setState({
          tech_page_flag: true,
          tech_page_icon_flag: tech_content[page_title]["tech_page_icon_flag"],
          tech_page_title: tech_content[page_title]["tech_page_title"],
          tech_page_desc: tech_content[page_title]["tech_page_desc"],
          tech_page_img: tech_content[page_title]["tech_page_img"],
          web_content: tech_content[page_title]["web_content"]
        })
      });
  }
}

export default TechPage;
